import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetTagMovimentacaoResponse, CreateTagMovimentacaoResponse } from '../../responses/financas/tag-movimentacao.response';
import { TagFinanceiraRequest } from '../../requests/financas/tag-financeira.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class TagMovimentacaoService extends CommonService {
    private readonly apiUrl: string = environment.urlApiFinancas + 'TagMovimentacao';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getAll(descricao: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetTagMovimentacaoResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (descricao) {
            params = params.set('descricao', descricao);
        }

        return this.httpClient
            .get<GetTagMovimentacaoResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public getById(id: number): Observable<CreateTagMovimentacaoResponse> {
        const url = `${this.apiUrl}/idTagMovimentacao/${id}`;
        return this.httpClient
            .get<CreateTagMovimentacaoResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public create(request: TagFinanceiraRequest): Observable<CreateTagMovimentacaoResponse> {
        return this.httpClient
            .post<CreateTagMovimentacaoResponse>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: TagFinanceiraRequest): Observable<CreateTagMovimentacaoResponse> {
        const url = `${this.apiUrl}/idTagMovimentacao/${id}`;
        return this.httpClient
            .put<CreateTagMovimentacaoResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(id: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/idTagMovimentacao/${id}`;
        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deleteBulk(ids: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;
        return this.httpClient
            .post<ReturnStruct>(url, { ids }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
